import { Switch, Route, useRouteMatch } from "react-router-dom"
import { FirmaClienteAdminPage } from './admin/FirmaClienteAdminPage';

const FirmaClienteRoutes = () => {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}/firma-cliente-admin`} component={FirmaClienteAdminPage} />
    </Switch>
  )
}
export default FirmaClienteRoutes;
